<template>
  <div class="aps">
    <div class="aps-head">
      <div class="aps-head-icon"><i class="fa fa-mobile"></i></div>
      <div>
        <h4>إعدادات تطبيق ولي الأمر</h4>
        <p>كل ما تغيّره هنا يظهر لأولياء الأمور في التطبيق بعد الضغط على «حفظ الإعدادات».</p>
      </div>
    </div>

    <div class="text-center g" v-if="!loaded">
      <img :src="require('@/assets/images/loading.svg')" alt="" width="50">
    </div>

    <div class="row" v-else>
      <div class="col-12 col-xl-7">
        <!-- موعد الخروج -->
        <section class="aps-card">
          <header>
            <span class="aps-ic red"><i class="fa fa-clock-o"></i></span>
            <div class="aps-title">
              <h5>موعد الخروج للطلاب</h5>
              <small>يظهر لولي الأمر في الرئيسية: «موعد الخروج اليوم».</small>
            </div>
            <label class="aps-switch" :class="{ disabled: !settings.dismissal_time }" title="إظهار في التطبيق">
              <input type="checkbox" :checked="settings.dismissal_show == 'yes'" :disabled="!settings.dismissal_time" @change="set('dismissal_show', $event.target.checked ? 'yes' : false)">
              <span></span>
              <b>{{ settings.dismissal_show == 'yes' && settings.dismissal_time ? 'ظاهر' : 'مخفي' }}</b>
            </label>
          </header>
          <div class="aps-body">
            <div class="dismissal">
              <div class="dismissal-field">
                <label for="dismissal-time">وقت الخروج</label>
                <input id="dismissal-time" type="time" class="form-control" :value="settings.dismissal_time" @input="setTime($event.target.value)">
              </div>
              <div class="quick">
                <span>اختيار سريع:</span>
                <button v-for="t in quickTimes" :key="t" type="button" class="chip" :class="{ on: settings.dismissal_time == t }" @click="setTime(t)">{{ time12(t) }}</button>
                <button v-if="settings.dismissal_time" type="button" class="chip clear" @click="setTime('')"><i class="fa fa-times"></i> إلغاء الموعد</button>
              </div>
            </div>
            <div class="preview">
              <span class="preview-label">في تطبيق ولي الأمر:</span>
              <span v-if="settings.dismissal_time && settings.dismissal_show == 'yes'" class="dismissal-chip">
                <i class="fa fa-clock-o"></i> موعد الخروج اليوم <b>{{ time12(settings.dismissal_time) }}</b>
              </span>
              <span v-else class="text-muted">لن يظهر شيء{{ settings.dismissal_time ? ' (مخفي)' : ' — لم يُحدَّد موعد' }}.</span>
            </div>
            <small class="text-muted d-block mt-50">يظهر من الأحد إلى الخميس فقط، ولا يظهر في الجمعة والسبت.</small>
          </div>
        </section>

        <!-- الأخبار والتنبيهات -->
        <section class="aps-card">
          <header>
            <span class="aps-ic blue"><i class="fa fa-bullhorn"></i></span>
            <div class="aps-title">
              <h5>الأخبار والتنبيهات <span class="count" v-if="settings.ads.length">{{ settings.ads.length }}</span></h5>
              <small>تظهر في الرئيسية في التطبيق، والخبر الهام يظهر كنافذة منبثقة.</small>
            </div>
            <button class="btn btn-primary btn-sm" @click="addAd()"><i class="fa fa-plus"></i> إضافة خبر</button>
          </header>
          <div class="aps-body">
            <div class="notify" v-if="newAd" :class="{ on: sendNotification }">
              <label class="aps-switch">
                <input type="checkbox" v-model="sendNotification">
                <span></span>
              </label>
              <div>
                <b>أرسل إشعاراً لأولياء الأمور بهذا الخبر عند الحفظ</b>
                <small class="d-block">عنوان الإشعار: «{{ newAd.title || 'خبر جديد' }}» — يصل لمن حمّل التطبيق.</small>
              </div>
            </div>

            <p class="empty" v-if="!settings.ads.length">لا توجد أخبار. اضغط «إضافة خبر» لإضافة أول خبر.</p>

            <div class="ad" v-for="ad in settings.ads" :key="ad.id" :class="{ fresh: isNew(ad) }">
              <div class="ad-top">
                <span class="badge-new" v-if="isNew(ad)">جديد</span>
                <input type="text" :id="'ad-title-' + ad.id" placeholder="عنوان الخبر" v-model="ad.title" class="form-control ad-title">
                <button class="icon-btn danger" title="حذف الخبر" @click="removeAd(ad)"><i class="fa fa-trash"></i></button>
              </div>
              <textarea :id="'ad-content-' + ad.id" rows="2" placeholder="التفاصيل..." v-model="ad.content" class="form-control"></textarea>

              <div class="ad-row">
                <div class="ad-image">
                  <img v-if="ad.image" :src="ad.image" alt="">
                  <label class="btn btn-sm btn-outline-secondary mb-0">
                    <i class="fa fa-image"></i> {{ ad.image ? 'تغيير الصورة' : 'إضافة صورة (اختياري)' }}
                    <input type="file" accept="image/*" hidden @change="uploadImage($event, ad)">
                  </label>
                  <a v-if="ad.image" href="javascript:;" class="text-danger small" @click="ad.image = ''">إزالة</a>
                </div>
                <label class="aps-switch small-sw" title="يظهر كنافذة منبثقة في الرئيسية، ويمكن لولي الأمر إغلاقها">
                  <input type="checkbox" v-model="ad.important">
                  <span></span>
                  <b>خبر هام (نافذة منبثقة)</b>
                </label>
              </div>

              <div class="ad-row">
                <div class="ad-action">
                  <label :for="'ad-do-' + ad.id">عند الضغط على الخبر</label>
                  <select :id="'ad-do-' + ad.id" class="form-control" v-model="ad.whatdo">
                    <option :value="undefined">لا شيء</option>
                    <option value="whatsapp">فتح محادثة واتساب</option>
                    <option value="link">فتح رابط</option>
                  </select>
                </div>
                <div class="ad-action" v-if="ad.whatdo == 'whatsapp'">
                  <label :for="'ad-phone-' + ad.id">رقم الواتساب (بالصيغة الدولية)</label>
                  <input :id="'ad-phone-' + ad.id" type="number" class="form-control ltr" v-model="ad.phone" placeholder="966503332...">
                </div>
                <div class="ad-action" v-if="ad.whatdo == 'link'">
                  <label :for="'ad-link-' + ad.id">الرابط</label>
                  <input :id="'ad-link-' + ad.id" type="url" class="form-control ltr" v-model="ad.link" placeholder="https://...">
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="col-12 col-xl-5">
        <!-- إضافة الطلاب -->
        <section class="aps-card">
          <header>
            <span class="aps-ic green"><i class="fa fa-user-plus"></i></span>
            <div class="aps-title">
              <h5>إضافة الطلاب</h5>
              <small>كيف يضيف ولي الأمر ابنه في التطبيق.</small>
            </div>
          </header>
          <div class="aps-body">
            <label class="aps-row">
              <span>السماح لأولياء الأمور بإضافة الطلاب</span>
              <span class="aps-switch"><input type="checkbox" :checked="!settings.no_add_students" @change="set('no_add_students', $event.target.checked ? false : 'yes')"><span></span></span>
            </label>
            <label class="aps-row">
              <span>طلب رقم الجوال عند الإضافة <small>يُضاف الطالب فقط إذا طابق الرقم المسجل في حسابه.</small></span>
              <span class="aps-switch"><input type="checkbox" :checked="!!settings.require_phone" @change="set('require_phone', $event.target.checked ? 'yes' : false)"><span></span></span>
            </label>
          </div>
        </section>

        <!-- ما يظهر لولي الأمر -->
        <section class="aps-card">
          <header>
            <span class="aps-ic violet"><i class="fa fa-id-card-o"></i></span>
            <div class="aps-title">
              <h5>ما يظهر لولي الأمر</h5>
              <small>أوقف أي خدمة لتختفي من صفحة الطالب في التطبيق.</small>
            </div>
          </header>
          <div class="aps-body">
            <label class="aps-row" v-for="f in features" :key="f.key">
              <span>{{ f.label }}</span>
              <span class="aps-switch"><input type="checkbox" :checked="!settings[f.key]" @change="set(f.key, $event.target.checked ? false : 'yes')"><span></span></span>
            </label>
            <div class="aps-sub">في سجل حضور الطالب</div>
            <label class="aps-row" v-for="f in statuses" :key="f.key">
              <span>{{ f.label }}</span>
              <span class="aps-switch"><input type="checkbox" :checked="!settings[f.key]" @change="set(f.key, $event.target.checked ? false : 'yes')"><span></span></span>
            </label>
          </div>
        </section>

        <!-- المحادثات -->
        <section class="aps-card">
          <header>
            <span class="aps-ic sky"><i class="fa fa-comments-o"></i></span>
            <div class="aps-title">
              <h5>المحادثات</h5>
              <small>مع من يستطيع ولي الأمر التواصل.</small>
            </div>
          </header>
          <div class="aps-body">
            <label class="aps-row">
              <span>التواصل مع المعلمين</span>
              <span class="aps-switch"><input type="checkbox" :checked="!settings.no_chat_teachers" @change="set('no_chat_teachers', $event.target.checked ? false : 'yes')"><span></span></span>
            </label>
            <label class="aps-row">
              <span>التواصل مع الإدارة</span>
              <span class="aps-switch"><input type="checkbox" :checked="!settings.no_chat_admin" @change="set('no_chat_admin', $event.target.checked ? false : 'yes')"><span></span></span>
            </label>
          </div>
        </section>
      </div>
    </div>

    <div class="aps-save" v-if="loaded">
      <span class="state" :class="{ dirty: dirty }">
        <i class="fa" :class="dirty ? 'fa-circle' : 'fa-check-circle'"></i>
        {{ dirty ? 'لديك تغييرات غير محفوظة' : 'كل التغييرات محفوظة' }}
      </span>
      <button class="btn btn-primary" @click="save()" :disabled="saving">
        <i class="fa" :class="saving ? 'fa-spinner fa-spin' : 'fa-save'"></i>
        حفظ الإعدادات{{ newAd && sendNotification ? ' وإرسال الإشعار' : '' }}
      </button>
    </div>
  </div>
</template>

<script>
// "صفحة المدرسة" features the parent app hides when `no_<key>` is 'yes' (switch on = shown).
const FEATURES = [
  { key: 'no_calls', label: 'نظام المناداة' },
  { key: 'no_full_report', label: 'التقرير الشامل' },
  { key: 'no_report', label: 'تقرير الحضور والغياب' },
  { key: 'no_points', label: 'نقاط التقييم' },
  { key: 'no_health', label: 'الملاحظات الصحية' },
  { key: 'no_bis', label: 'المخالفات السلوكية' },
  { key: 'no_breaks', label: 'المواقف الطارئة' },
  { key: 'no_visits', label: 'الزيارات' },
  { key: 'no_tasks', label: 'المهام' },
];
const STATUSES = [
  { key: 'no_status_1', label: 'أيام الحضور' },
  { key: 'no_status_2', label: 'أيام التأخر' },
  { key: 'no_status_3', label: 'أيام الغياب' },
];

export default {
  data(){
    return {
      user: JSON.parse(localStorage.getItem('user')),
      settings: { ads: [] },
      loaded: false,
      saving: false,
      sendNotification: true,
      originalAdIds: [],
      saved: '',
      features: FEATURES,
      statuses: STATUSES,
      quickTimes: ['11:00', '11:30', '12:00', '12:30', '13:00', '13:30'],
      date: new Date().toISOString().split('T')[0],
    }
  },
  computed: {
    dirty(){
      return this.loaded && JSON.stringify(this.settings) != this.saved;
    },
    // The first news added since the last save: its title is the notification.
    newAd(){
      var originals = this.originalAdIds;
      return (this.settings.ads || []).find(function(a){
        return a && a.id && originals.indexOf(a.id) === -1 && (a.title || a.content);
      }) || null;
    },
  },
  created(){
    if(!checkPer("app-settings")){
      this.$router.push('/NotPermitted')
      return false;
    }
    var g = this;
    $.post(api + '/user/general/settings/app-settings', {
      jwt: this.user.jwt
    }).then(function(r){
      var s = r.response || {};
      for (const [key, value] of Object.entries(s)) {
        if(key != "ads" && key != "dismissal_time"){
          s[key] = value == 'yes' ? 'yes' : false
        }
      }
      if(!Array.isArray(s.ads)) s.ads = [];
      if(typeof s.dismissal_time != 'string') s.dismissal_time = '';
      if(s.dismissal_show === undefined) s.dismissal_show = false;
      g.settings = s
      g.originalAdIds = s.ads.map(function(a){ return a.id }).filter(function(x){ return x })
      g.saved = JSON.stringify(s)
      g.loaded = true
    })
  },
  methods: {
    set(key, value){
      this.$set(this.settings, key, value);
    },
    setTime(t){
      var had = !!this.settings.dismissal_time;
      this.set('dismissal_time', t || '');
      // Picking a time for the first time shows it; clearing hides it.
      if(t && !had) this.set('dismissal_show', 'yes');
      if(!t) this.set('dismissal_show', false);
    },
    time12(t){
      var m = /^(\d{1,2}):(\d{2})/.exec(t || '');
      if(!m) return '';
      var h = parseInt(m[1]);
      return (h % 12 || 12) + ':' + m[2] + (h < 12 ? ' ص' : ' م');
    },
    isNew(ad){
      return this.originalAdIds.indexOf(ad.id) === -1;
    },
    addAd(){
      var id = Math.random().toString();
      this.settings.ads.unshift({
        title: '',
        content: '',
        date: this.date,
        url: '',
        image: '',
        important: false,
        id: id
      });
      this.$nextTick(function(){
        var el = document.getElementById('ad-title-' + id);
        if(el) el.focus();
      });
    },
    removeAd(ad){
      if((ad.title || ad.content) && !confirm('حذف الخبر «' + (ad.title || 'بدون عنوان') + '»؟')) return;
      this.settings.ads = this.settings.ads.filter(function(x){ return x.id != ad.id });
    },
    save(){
      var g = this;
      var notifyAd = g.sendNotification && g.newAd ? {
        title: g.newAd.title || '',
        content: g.newAd.content || ''
      } : null;
      g.saving = true;
      $.post(api + '/user/general/settings/app-settings/save', {
        jwt: this.user.jwt,
        object: JSON.stringify(g.settings)
      }).then(function(r){
        g.saving = false
        if(r.status != 100){
          alert(r.response)
          return;
        }
        g.originalAdIds = (g.settings.ads || []).map(function(a){ return a.id }).filter(function(x){ return x })
        g.saved = JSON.stringify(g.settings)
        if(notifyAd){
          $.post(api + '/user/general/settings/app-settings/notify', {
            jwt: g.user.jwt,
            title: notifyAd.title,
            body: notifyAd.content
          }).then(function(rr){
            if(rr.status == 100){
              alert("تم الحفظ وإرسال الإشعار إلى " + (rr.response || 0) + " من أولياء الأمور", 100)
            }else{
              alert("تم الحفظ ولكن فشل إرسال الإشعار", 200)
            }
          }).fail(function(){
            alert("تم الحفظ ولكن فشل الاتصال بخادم الإشعارات", 200)
          })
        }else{
          alert("تم الحفظ", 100)
        }
      }).fail(function(){
        g.saving = false
        alert("حدث خطأ في الاتصال", 200)
      })
    },
    uploadImage(event, ad){
      var g = this;
      var file = event.target.files && event.target.files[0];
      if(!file) return;
      var formData = new FormData();
      formData.append("file", file, file.name);
      formData.append("jwt", g.user.jwt);
      $.ajax({
        type: "POST",
        url: api + '/user/general/upload',
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        success: function(data){
          if(data.status != 100){
            alert("هذا الملف غير مدعوم", 200)
            return;
          }
          g.$set(ad, 'image', data.response)
        },
        error: function(){
          alert("حدث خطأ في رفع الصورة", 200)
        }
      })
      event.target.value = '';
    },
  }
}
</script>

<style scoped>
.aps {
  padding-bottom: 84px;
}
.aps-head {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
}
.aps-head-icon {
  width: 46px;
  height: 46px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  font-size: 24px;
  color: var(--sk-p, #1D4ED8);
  background: var(--sk-ps, #E8EEFD);
  flex-shrink: 0;
}
.aps-head h4 {
  margin: 0 0 2px;
  font-weight: 700;
  color: var(--sk-ink, #0F1733);
}
.aps-head p {
  margin: 0;
  color: var(--sk-muted, #667085);
  font-size: 13px;
}
.aps-card {
  background: var(--sk-card, #fff);
  border: 1px solid var(--sk-line, #D5DAE3);
  border-radius: 16px;
  box-shadow: var(--sk-shadow, none);
  margin-bottom: 16px;
  overflow: hidden;
}
.aps-card > header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--sk-line, #D5DAE3);
}
.aps-title {
  flex: 1;
  min-width: 0;
}
.aps-title h5 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: var(--sk-ink, #0F1733);
}
.aps-title small {
  color: var(--sk-muted, #667085);
  font-size: 12px;
}
.aps-title .count {
  display: inline-block;
  min-width: 22px;
  padding: 0 7px;
  border-radius: 999px;
  font-size: 11px;
  line-height: 20px;
  text-align: center;
  background: var(--sk-ps, #E8EEFD);
  color: var(--sk-p, #1D4ED8);
  margin-inline-start: 4px;
}
.aps-ic {
  width: 36px;
  height: 36px;
  border-radius: 11px;
  display: grid;
  place-items: center;
  font-size: 17px;
  flex-shrink: 0;
}
.aps-ic.red { background: var(--sk-bads, #FEE4E2); color: var(--sk-badi, #B42318); }
.aps-ic.blue { background: var(--sk-ps, #E8EEFD); color: var(--sk-p, #1D4ED8); }
.aps-ic.green { background: var(--sk-oks, #DCFAE6); color: var(--sk-oki, #067647); }
.aps-ic.violet { background: #EEEAFD; color: #5B3FD6; }
.aps-ic.sky { background: var(--sk-ins, #E0F2FE); color: var(--sk-ini, #026AA2); }
.aps-body {
  padding: 14px 16px;
}

/* switches */
.aps-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
  user-select: none;
}
.aps-switch input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.aps-switch > span {
  width: 40px;
  height: 22px;
  border-radius: 999px;
  background: var(--sk-field, #BFC6D1);
  position: relative;
  transition: background .15s;
}
.aps-switch > span::after {
  content: '';
  position: absolute;
  top: 3px;
  inset-inline-start: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
  transition: transform .15s;
}
.aps-switch input:checked + span {
  background: var(--sk-p, #1D4ED8);
}
[dir="rtl"] .aps-switch input:checked + span::after {
  transform: translateX(-18px);
}
[dir="ltr"] .aps-switch input:checked + span::after {
  transform: translateX(18px);
}
.aps-switch input:focus-visible + span {
  outline: 2px solid var(--sk-p, #1D4ED8);
  outline-offset: 2px;
}
.aps-switch b {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--sk-text, #344054);
}
.aps-switch.disabled {
  opacity: .5;
  cursor: not-allowed;
}
.aps-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 0;
  margin: 0;
  cursor: pointer;
  border-bottom: 1px dashed var(--sk-line, #D5DAE3);
  color: var(--sk-text, #344054);
  font-size: 13.5px;
}
.aps-row:last-child {
  border-bottom: 0;
}
.aps-row small {
  display: block;
  color: var(--sk-muted, #667085);
  font-size: 11.5px;
}
.aps-sub {
  margin: 12px 0 2px;
  font-size: 12px;
  font-weight: 700;
  color: var(--sk-muted, #667085);
}

/* dismissal time */
.dismissal {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
}
.dismissal-field label {
  font-size: 12px;
  color: var(--sk-muted, #667085);
  margin-bottom: 4px;
}
.dismissal-field input {
  width: 150px;
  font-weight: 700;
  font-size: 16px;
  direction: ltr;
  text-align: center;
}
.quick {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--sk-muted, #667085);
}
.chip {
  border: 1px solid var(--sk-line, #D5DAE3);
  background: var(--sk-card, #fff);
  color: var(--sk-text, #344054);
  border-radius: 999px;
  padding: 3px 11px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.chip:hover {
  border-color: var(--sk-p, #1D4ED8);
}
.chip.on {
  background: var(--sk-ps, #E8EEFD);
  border-color: var(--sk-p, #1D4ED8);
  color: var(--sk-p, #1D4ED8);
}
.chip.clear {
  color: var(--sk-badi, #B42318);
}
.preview {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--sk-soft, #F6F7FB);
  font-size: 13px;
}
.preview-label {
  color: var(--sk-muted, #667085);
  font-size: 12px;
}
.dismissal-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  background: var(--sk-bads, #FEE4E2);
  color: var(--sk-badi, #B42318);
  font-size: 12.5px;
  font-weight: 600;
}

/* news */
.notify {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 13px;
  border-radius: 12px;
  border: 1px solid var(--sk-line, #D5DAE3);
  background: var(--sk-soft, #F6F7FB);
  margin-bottom: 12px;
  font-size: 13px;
  color: var(--sk-text, #344054);
}
.notify.on {
  border-color: var(--sk-p, #1D4ED8);
  background: var(--sk-ps, #E8EEFD);
}
.notify small {
  color: var(--sk-muted, #667085);
}
.empty {
  text-align: center;
  color: var(--sk-muted, #667085);
  margin: 6px 0;
  font-size: 13px;
}
.ad {
  border: 1px solid var(--sk-line, #D5DAE3);
  border-radius: 14px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 9px;
}
.ad + .ad {
  margin-top: 10px;
}
.ad.fresh {
  border-color: var(--sk-p, #1D4ED8);
}
.ad-top {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ad-title {
  font-weight: 700;
}
.badge-new {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--sk-p, #1D4ED8);
  color: #fff;
}
.icon-btn {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid var(--sk-line, #D5DAE3);
  background: transparent;
  cursor: pointer;
}
.icon-btn.danger {
  color: var(--sk-badi, #B42318);
}
.icon-btn.danger:hover {
  background: var(--sk-bads, #FEE4E2);
}
.ad-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
}
.ad-image {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ad-image img {
  width: 44px;
  height: 44px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid var(--sk-line, #D5DAE3);
}
.ad-action {
  flex: 1;
  min-width: 180px;
}
.ad-action label {
  font-size: 12px;
  color: var(--sk-muted, #667085);
  margin-bottom: 3px;
}
.small-sw b {
  font-size: 12px;
}
.ltr {
  direction: ltr;
  text-align: left;
}

/* save bar */
.aps-save {
  position: sticky;
  bottom: 12px;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 14px;
  border-radius: 14px;
  background: var(--sk-card, #fff);
  border: 1px solid var(--sk-line, #D5DAE3);
  box-shadow: var(--sk-pop, 0 8px 24px rgba(0, 0, 0, .12));
}
.aps-save .state {
  font-size: 13px;
  color: var(--sk-oki, #067647);
}
.aps-save .state.dirty {
  color: var(--sk-wai, #B54708);
}
.aps-save .state .fa-circle {
  font-size: 9px;
  vertical-align: middle;
}
</style>
